import "../styles/About.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";

function About() {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />

      <div className="about-page">

        {/* HERO */}
        <section className="about-hero">
          <div className="about-overlay"></div>

          <div className="about-hero-content">
            <span className="about-tag">
              {t("about_hero_tag")}
            </span>

            <h1>{t("about_hero_title")}</h1>

            <p>
              {t("about_hero_desc")}
            </p>
          </div>
        </section>

        {/* ABOUT INTRO */}
        <section className="about-intro">
          <div className="container">

            <div className="intro-text">
              <h2>{t("about_intro_title")}</h2>

              <p>
                {t("about_intro_text1")}
              </p>

              <p>
                {t("about_intro_text2")}
              </p>
            </div>

            <div className="intro-boxes">

              <div className="box">
                <h3>{t("about_quality_title")}</h3>
                <p>{t("about_quality_text")}</p>
              </div>

              <div className="box">
                <h3>{t("about_strength_title")}</h3>
                <p>{t("about_strength_text")}</p>
              </div>

              <div className="box">
                <h3>{t("about_precision_title")}</h3>
                <p>{t("about_precision_text")}</p>
              </div>

            </div>

          </div>
        </section>

        {/* PRODUCTS BRIEF */}
        <section className="about-products">
          <div className="container">

            <div className="section-title">
              <h2>{t("about_products_title")}</h2>
              <p>{t("about_products_desc")}</p>
            </div>

            <div className="products-grid">

              <div className="product-box">
                <h3>Jumbo Bags</h3>
                <p>{t("about_jumbo_bags_text")}</p>
              </div>

              <div className="product-box">
                <h3>Sling Bags</h3>
                <p>{t("about_sling_bags_text")}</p>
              </div>

              <div className="product-box">
                <h3>Woven Bags</h3>
                <p>{t("about_woven_bags_text")}</p>
              </div>

              <div className="product-box">
                <h3>Custom Packaging</h3>
                <p>{t("about_custom_packaging_text")}</p>
              </div>

            </div>

          </div>
        </section>

        {/* INDUSTRIES */}
        <section className="industries">
          <div className="container">

            <div className="section-title center">
              <h2>{t("about_industries_title")}</h2>
              <p>{t("about_industries_desc")}</p>
            </div>

            <div className="industries-grid">

              <div className="industry">
                {t("industry_agriculture")}
              </div>

              <div className="industry">
                {t("industry_food")}
              </div>

              <div className="industry">
                {t("industry_construction")}
              </div>

              <div className="industry">
                {t("industry_export")}
              </div>

              <div className="industry">
                {t("industry_chemical")}
              </div>

              <div className="industry">
                {t("industry_logistics")}
              </div>

            </div>

          </div>
        </section>

        {/* CTA */}
        <section className="about-cta">
          <div className="cta-box">

            <h2>{t("about_cta_title")}</h2>

            <p>
              {t("about_cta_desc")}
            </p>

            <a href="/contact" className="cta-btn">
              {t("about_cta_button")}
            </a>

          </div>
        </section>

      </div>

      <Footer />
    </>
  );
}

export default About;